'use client';

import { type PropsWithChildren, useRef } from 'react';
import { PaginationProvider } from '@/components/Pagination/PaginationContext';

export interface ScrollablePaginationWrapperProps extends PropsWithChildren {
    onPageChange?: (page: number) => void;
    options?: ScrollIntoViewOptions;
}

export function ScrollablePaginationWrapper({ children, onPageChange: inOnPageChange, options }: ScrollablePaginationWrapperProps) {
    const ref = useRef<HTMLDivElement>(null);
    const onPageChange = (page: number) => {
        ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', ...options });
        inOnPageChange?.(page);
    };

    return (
        <div data-testid="scrollable-pagination-wrapper" ref={ref}>
            <PaginationProvider onPageChange={onPageChange}>{children}</PaginationProvider>
        </div>
    );
}
